import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { Upload, message, Image } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import cloudIcon from 'utils/icon/icon_cloud-upload-image-black.svg';
import uploadIcon from 'utils/icon/icon_upload-image-black.svg';
import plusButtonIcon from 'utils/icon/icon_plus-blue.svg';
import PrimaryButton from 'components/button/PrimaryButton';
import { useTranslation } from 'react-i18next';
import { Trash } from 'iconsax-react';
import { itemApis } from 'apis/package/itemApis';
import {
  showApiSuccessMessage,
  showStringErrorMessage,
} from 'utils/helper/message';
import { charactersApis } from 'apis/characters/charactersApis';

/**
 * * 이미지 업로드 구역
 */

interface IProps {
  targetData: any;
  setTargetData: React.Dispatch<React.SetStateAction<any>>;
  projectId: string | undefined;
  image_type: string; // icon, image.. etc
  api_target: string; // api 타겟
}

// * 단일 이미지 업로드 Compoment.
// * API 전달받아야할것같은데..
const UploadSingleImage: React.FC<IProps> = ({
  targetData,
  setTargetData,
  projectId,
  image_type, // icon, banner, thumbnail, image 4가지 있음.
  api_target,
}) => {
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    if (targetData) {
      console.log(targetData);

      setImage(
        image_type === 'icon' ? targetData?.icon_url : targetData?.image_url,
      );
    }
  }, [targetData]);

  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  // 업로드 진행
  const uploadAvatar = async (options) => {
    const { file, onSuccess, onError } = options;

    const isPNG = file.type === 'image/png';
    const isJPG = file.type === 'image/jpeg';

    if (!isPNG && !isJPG) {
      showStringErrorMessage('파일 형식이 올바르지 않습니다.');
      return;
    }

    if (file.size > 8000000) {
      showStringErrorMessage('8MB 이상의 파일을 업로드 할 수 없습니다');
      return;
    }

    if (!targetData) {
      showStringErrorMessage('대상이 되는 데이터가 없습니다.');
      return;
    }

    console.log(`UploadSingleImage uplaod start...!`);

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);

      //   const requestAPI =
      //     image_type === 'icon'
      //       ? itemApis.itemUpdateIcon(projectId, targetData.id, formData)
      //       : itemApis.itemUpdateImage(projectId, targetData.id, formData);

      let requestAPI: Promise<any> | null = null;

      // * 중요(사용처에 따라서 늘려야함)
      if (api_target == 'item') {
        requestAPI =
          image_type == 'icon'
            ? itemApis.itemUpdateIcon(projectId, targetData.id, formData)
            : itemApis.itemUpdateImage(projectId, targetData.id, formData);
      } else if (api_target == 'ability') {
        requestAPI = charactersApis.uploadAbilityIcon(
          projectId,
          targetData.profile_id,
          targetData.ability_id,
          formData,
        );
      }

      if (!requestAPI) {
        showStringErrorMessage('UploadSingleImage의 목표가 올바르지 않습니다.');
        setLoading(false);
        return;
      }

      const res = await requestAPI;

      console.log(`uploading done : `, res);

      const cloneData = structuredClone(targetData);

      if (image_type === 'icon') {
        cloneData.icon_url = res.icon_url;
        cloneData.icon_key = res.icon_key;

        if (cloneData.icon_bucket != undefined)
          cloneData.icon_bucket = res.icon_bucket;

        if (cloneData.bucket != undefined) cloneData.bucket = res.bucket;
      } else if (image_type == 'image') {
        cloneData.image_key = res.image_key;
        cloneData.image_url = res.image_url;
      } else if (image_type == 'banner') {
        cloneData.banner_key = res.banner_key;
        cloneData.banner_url = res.banner_url;
      } else if (image_type == 'thumbnail') {
        cloneData.thumbnail_key = res.thumbnail_key;
        cloneData.thumbnail_url = res.thumbnail_url;
      }

      setTargetData(cloneData);
      onSuccess('ok');

      showApiSuccessMessage('이미지가 업로드되었습니다.');
      setLoading(false);
    } catch (err) {
      console.log('Error', err);

      showStringErrorMessage('이미지 업로드에 실패했습니다.');

      onError(err);
      setLoading(false);
    }
  };

  const props = {
    name: 'file',
    action: '',
    showUploadList: false,
    accept: 'image/png, image/jpeg',
    async onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log('uploading ===>', info.file, info.fileList);
      }
      if (info.file.status === 'done') {
      } else if (info.file.status === 'error') {
        console.log('failed ===>', info.file);
      }
    },
  };

  // 이미지 제거.
  const handleRemoveImage = () => {
    setImage(null);

    const cloneData = structuredClone(targetData);

    if (image_type === 'icon') {
      cloneData.icon_key = null;
      cloneData.icon_url = null;
    } else if (image_type == 'image') {
      cloneData.image_key = null;
      cloneData.image_url = null;
    } else if (image_type == 'banner') {
      cloneData.banner_key = null;
      cloneData.banner_url = null;
    } else if (image_type == 'thumbnail') {
      cloneData.thumbnail_key = null;
      cloneData.thumbnail_url = null;
    }
    // 갱신
    setTargetData(cloneData);
  };

  return (
    <>
      <UploadWrapper>
        <UploadContentWrapper>
          <div>
            {loading ? (
              <div className='flex-wrap icon'>
                <LoadingOutlined style={{ fontSize: '50px' }} />
              </div>
            ) : image ? (
              <Image src={image} alt={`thumbnail`} className='icon' />
            ) : (
              <></>
            )}
          </div>
        </UploadContentWrapper>
        {!loading && (
          <div className='uploadTotalWrap'>
            <Upload {...props} maxCount={1} customRequest={uploadAvatar}>
              {image ? (
                <div style={{ marginLeft: 24 }}>
                  <PrimaryButton
                    text={t('buttons.replaceImage')}
                    height='40px'
                    width='fit-content'
                    bgColor='#ffffff'
                    textColor={theme.colors.dark_400}
                    fontWeight={theme.fontWeights.medium}
                    fontSize={theme.fontSizes.normal}
                    border={`1px solid ${theme.colors.gray_6}`}
                    rounded='6px'
                    hoverBgColor={theme.colors.gray_6}
                    activeBgColor={theme.colors.gray_6}
                    selectedBgColor={theme.colors.gray_6}
                    loading={loading}
                    LeftPlaceHolder={<img src={uploadIcon} alt='upload' />}
                  />
                  <p className='turText'>{t('updateStory.form.required')}</p>
                </div>
              ) : (
                <>
                  <div className='emptyImage'>
                    <img src={cloudIcon} alt='upload cloud' />
                    <p className='emptyImageText'>
                      이미지 파일을 선택하거나 끌어놓으세요. 이미지는 업로드
                      즉시 반영됩니다.
                    </p>
                    <img src={plusButtonIcon} alt='plus icon' />
                  </div>
                  <p className='turText'>{t('updateStory.form.required')}</p>
                </>
              )}
            </Upload>
            {image && (
              <PrimaryButton
                text={t('buttons.remove')}
                height='40px'
                width='fit-content'
                bgColor='#ffffff'
                textColor={theme.colors.dark_400}
                fontWeight={theme.fontWeights.medium}
                fontSize={theme.fontSizes.normal}
                border={`1px solid ${theme.colors.gray_6}`}
                rounded='6px'
                hoverBgColor={theme.colors.gray_6}
                activeBgColor={theme.colors.gray_6}
                selectedBgColor={theme.colors.gray_6}
                loading={loading}
                onClick={handleRemoveImage}
                LeftPlaceHolder={<Trash size='24' />}
              />
            )}
          </div>
        )}
      </UploadWrapper>
      {/* {contextHolder} */}
    </>
  );
};

export default UploadSingleImage;

const UploadContentWrapper = styled.div`
  .upload {
    border: 1px solid ${theme.colors.gray_7};
    border-style: dotted;
  }
  .flex-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .icon {
    width: 136px;
    height: 136px;
    object-fit: cover;
  }
`;

const UploadWrapper = styled.div`
  position: relative;
  display: flex;
  .emptyImage {
    border: 1px solid ${theme.colors.dark_100};
    border-radius: 4px;
    border-style: dotted;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
    & > * + * {
      margin-top: 10px;
    }
    cursor: pointer;
  }
  .turText {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px;
  }
  .emptyImageText {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .uploadTotalWrap {
    display: flex;
    & > * + * {
      margin-left: 8px;
    }
  }
  & > * + * {
    /* margin-left: 24px; */
    /* column-gap: 24px; */
  }
`;
